import { Chip, chipClasses } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'

export const PendingNamespaceAccessRequestChip: React.FC<{
  namespace: string
  isRequesting: boolean
  onDelete(): void
}> = ({ namespace, isRequesting, onDelete }) => {
  const label = isRequesting
    ? `Requesting: ${namespace}`
    : `Requested: ${namespace}`

  return (
    <Chip
      avatar={<Icon icon="solidCirclesOverlap" />}
      color="primary"
      data-testid={`chip-pending-namespace-request-${namespace}`}
      label={label}
      sx={{
        margin: 0.5,
        width: 'fit-content',
        [`.${chipClasses.avatarColorPrimary}`]: {
          backgroundColor: 'transparent'
        }
      }}
      onDelete={onDelete}
    />
  )
}
